import { Component, OnInit } from '@angular/core';
import { LoginComponent } from './../login/login.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import * as moment from 'moment';

import { ResendVerificationComponent } from './../resend-verification/resend-verification.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router, private dialog: MatDialog, private snackBar: MatSnackBar) { }

  ngOnInit() {
  }

  onSignUp(form: NgForm) {
    if (form.value.email === '' || form.value.password === '' || form.value.mobile === '' || form.value.reference === '' || form.value.firstName === '' || form.value.lastName === '' || form.value.dateOfBirth === '') {
      this.snackBar.open('Please fill all required fields', 'Dismiss', {
        duration: 3000
      })
      return;
    }

    if (form.value.tnc === '' || form.value.tnc == false) {
      form.value.tnc = false;
      this.snackBar.open('You must agree to our terms and conditions', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    if (form.value.promotionPermission === '') {
      form.value.promotionPermission = false;
    }

    this.authService.signup(
      form.value.firstName,
      form.value.lastName,
      form.value.email,
      form.value.password,
      form.value.mobile,
      form.value.reference,
      // moment(form.value.dateOfBirth).format('DD-MM-YYYY'),
      form.value.promotionPermission
    );
  }

  onLogin() {
    this.dialog.open(LoginComponent);
  }

  onTnC() {
    this.dialog.closeAll();
    this.router.navigate(['/terms-and-conditions']);
  }
}
